<template>
  <section class="custom-form">
    <z-tabs v-model="adminTab" :tabs="tabs" @change="showTab" />
    <div v-if="adminTab === 'General'" class="row p-2 custom-form">
      <adas-config />
    </div>
    <div v-if="adminTab === 'Repair Links'" class="row p-2 custom-form">
      <repair-links />
    </div>
    <div v-if="adminTab === 'ADAS Matrix'" class="row p-2 custom-form">
      <adas-matrix />
    </div>
    <div v-if="adminTab === 'ADAS Exclusions'" class="row p-2 custom-form">
      <adas-exclusions />
    </div>
    <div v-if="adminTab === 'ADAS Info'" class="row p-2 custom-form">
      <adas-info />
    </div>
    <div v-if="adminTab === 'VIN Decode'" class="row p-2 custom-form">
      <vin-decode />
    </div>
    <div v-if="adminTab === 'Report'" class="row p-2 custom-form">
      <report-config />
    </div>
    <div v-if="adminTab === 'No Scrub List'" class="row p-2 custom-form">
      <no-scrub />
    </div>
    <div v-if="adminTab === 'Import/Export'" class="row p-2 custom-form">
      <matrix-import-host />
    </div>
    <div v-if="adminTab === 'Push'" class="row p-2 custom-form">
      <matrix-push />
    </div>
  </section>
</template>
<script>
import { mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import AdasConfig from '@/components/adasmatrix/adas-config.vue'
import AdasMatrix from '@/components/adasmatrix/adas-matrix.vue'
import AdasExclusions from '@/components/adasmatrix/adas-exclusions.vue'
import AdasInfo from '@/components/adasmatrix/adas-info.vue'
import VinDecode from '@/components/adasmatrix/vin-decode.vue'
import MatrixImportHost from '@/components/adasmatrix/matrix-import-host.vue'
import MatrixPush from '@/components/adasmatrix/matrix-push.vue'
import ReportConfig from '@/components/adasmatrix/report-config.vue'
import NoScrub from '@/components/adasmatrix/no-scrub.vue'
import RepairLinks from '@/components/adasmatrix/repair-links.vue'
export default {
  name: 'AdminConfig',
  components: {
    ZTabs,
    AdasConfig,
    AdasMatrix,
    AdasExclusions,
    AdasInfo,
    VinDecode,
    MatrixImportHost,
    MatrixPush,
    ReportConfig,
    NoScrub,
    RepairLinks
  },
  data() {
    return {
      adminTab: 'General',
      tabs: ['General', 'Repair Links', 'ADAS Matrix', 'ADAS Exclusions', 'ADAS Info', 'VIN Decode', 'Report', 'No Scrub List', 'Import/Export', 'Push']
    }
  },
  async mounted() {
    await this.getLookups({
      keys: [
        'VehicleMake',
        'CalibrationType',
        'Source',
        'CCCKeywordType',
        'SystemType',
        'LocationType',
        'CCCItemType',
        'MitchellItemType',
        'Insurance'
      ],
      firm: 1,
      refresh: true
    })
  },
  methods: {
    ...mapActions(adasmatrixStore, ['getLookups', 'setRecommendation', 'getRecommendations']),
    showTab(value) {
      if (value === 'Report') {
        this.setRecommendation({
          name: 'reset',
          value: null
        })
        this.getRecommendations()
      }
      this.adminTab = value
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-form {
  width: 100%;
}
</style>
